/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { CardWithProgress } from '@app/app/page-modules/resource/models';
import { ApprovalRequest, AssociateCategoryRequest } from '../../models';
import { ObservableResult } from '../../store';
import { SharedCardDataService } from './card-data.service';

@Injectable()
export class MockSharedCardDataService implements SharedCardDataService {
  registerCardOpen(): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  getCardDetails(cardUri: string): ObservableResult<CardWithProgress> {
    return ObservableResult.ofSuccess();
  }

  associateTag(resourceUid: string, tagUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  dissociateTag(resourceUid: string, tagUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  updateCardUri(resourceUid: string, newUri: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  publishCard(resourceUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  unpublishCard(resourceUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  archiveCard(resourceUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  updateApprovalMethod(resourceUid: string, request: ApprovalRequest): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  getReviewsCount(cardId: string): ObservableResult<number> {
    return ObservableResult.ofSuccess();
  }

  associateReviewer(resourceUid: string, userUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  dissociateReviewer(resourceUid: string, userUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  associateCategory(cardUid: string, request: AssociateCategoryRequest): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  dissociateCategory(cardUid: string, categoryTagUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  associateTargetGroup(cardId: string, groupUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  dissociateTargetGroup(cardId: string, groupUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  associateTargetUser(cardId: string, userUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  dissociateTargetUser(cardId: string, userUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }
}
